module.exports = __webpack_public_path__ + "img/HomePageImage.b08a9b7f.png";